import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboardStatistics } from '../../utils/apiHelper';
import InfoTooltip from './InfoTooltip';

const ALERT_CONFIG = [
  {
    key: 'pendingOrders',
    label: 'Bekleyen Sipariş',
    icon: 'fas fa-clock',
    type: 'warning',
    tooltip: 'PENDING durumundaki tüm siparişler',
    navigateTo: '/admin/orders?status=PENDING'
  },
  {
    key: 'staleOrders',
    label: '3+ Gün İşlenmemiş',
    icon: 'fas fa-exclamation-triangle',
    type: 'danger',
    tooltip: '3 günden uzun süredir PENDING veya PROCESSING durumunda olan siparişler',
    navigateTo: '/admin/orders?status=PENDING'
  },
  {
    key: 'paymentIssues',
    label: 'Ödeme Sorunu',
    icon: 'fas fa-credit-card',
    type: 'danger',
    tooltip: 'PAYMENT_FAILED durumundaki abonelikler — ödeme alınamayan aktif müşteriler',
    navigateTo: '/admin/subscriptions?status=PAYMENT_FAILED'
  },
  {
    key: 'lowStockProducts',
    label: 'Düşük Stok',
    icon: 'fas fa-box-open',
    type: 'stock',
    tooltip: 'Stok seviyesi 10 veya altında olan aktif ürünler',
    navigateTo: '/admin/products?stockFilter=low'
  },
  {
    key: 'missedOrders',
    label: 'Sipariş Oluşmamış',
    icon: 'fas fa-unlink',
    type: 'error',
    tooltip: 'Teslimat tarihi geçmiş ama son 7 günde siparişi oluşturulamamış aktif abonelikler',
    navigateTo: '/admin/subscriptions'
  },
  {
    key: 'recentErrors',
    label: 'Kritik Hata (24s)',
    icon: 'fas fa-bug',
    type: 'error',
    tooltip: 'Son 24 saatte oluşan okunmamış ERROR ve DELIVERY_FAILED bildirimleri',
    navigateTo: '/admin/notifications'
  }
];

const AlertCards = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getDashboardStatistics.alerts();
        if (res?.success) setData(res.statistics);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) {
    return (
      <div className="dashboard-section">
        <div className="dashboard-section-title">
          <i className="fas fa-bell"></i> Dikkat Gerektiren
        </div>
        <div className="section-loading">
          <div className="spinner-border spinner-border-sm me-2" role="status"></div>
          Yükleniyor...
        </div>
      </div>
    );
  }

  if (error || !data) return null; // Silent fail — alerts are supplementary

  // Filter out outOfStockProducts (merged into lowStock display)
  const totalLowStock = (data.lowStockProducts || 0) + (data.outOfStockProducts || 0);
  const mergedData = { ...data, lowStockProducts: totalLowStock };

  return (
    <div className="dashboard-section">
      <div className="dashboard-section-title">
        <i className="fas fa-bell"></i> Dikkat Gerektiren
        <InfoTooltip text="Acil müdahale veya dikkat gerektiren öğeler. 0 ise sorun yok demektir." />
      </div>
      <div className="alert-cards-grid">
        {ALERT_CONFIG.map(cfg => {
          const count = mergedData[cfg.key] || 0;
          const isActive = count > 0;

          return (
            <div
              key={cfg.key}
              className={`alert-card type-${cfg.type} ${isActive ? 'active' : 'dimmed'}`}
              onClick={isActive ? () => navigate(cfg.navigateTo) : undefined}
              role={isActive ? 'button' : undefined}
              tabIndex={isActive ? 0 : undefined}
              onKeyDown={isActive ? (e) => e.key === 'Enter' && navigate(cfg.navigateTo) : undefined}
            >
              <div className="alert-icon">
                <i className={cfg.icon}></i>
              </div>
              <div className="alert-body">
                <div className="alert-count">{count}</div>
                <div className="alert-label" title={cfg.label}>{cfg.label}</div>
              </div>
              {isActive && (
                <i className="fas fa-chevron-right" style={{ color: 'var(--admin-text-muted)', fontSize: '0.7rem' }}></i>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AlertCards;
